export enum ERSTabType {
    About = 'About',
    Technology = 'Technology',
    Collaborators = 'Collaborators',
    Reflection = 'Reflection'
}